const properties = { keys: { user_id: 'user_id' } };

export default properties;
